import React, { useState } from 'react';
import image1 from './film1.jpg';
import image2 from './film2.jpg';
import image3 from './film3.jpg';
import Buttons from './components/ui/Button/Button';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import './App.css';

import {
  Autoplay,
  EffectCoverflow,
  Pagination,
  Navigation,
} from 'swiper/modules';

const FilmsSection = () => {
  const images = [image1, image2, image3, image1, image2, image3];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const nextImage = () => {
    setFade(false);
    setTimeout(() => {
      setCurrentIndex((currentIndex + 1) % images.length);
      setFade(true);
    }, 200);
  };

  const prevImage = () => {
    setFade(false);
    setTimeout(() => {
      setCurrentIndex((currentIndex - 1 + images.length) % images.length);
      setFade(true);
    }, 200);
  };

  return (
    <div className=" text-white w-full min-h-[60vh] lg:min-h-screen flex flex-col justify-center items-center ">
      {/* Header */}
      <div className="flex flex-row justify-between items-center w-full max-w-7xl mb-6 sm:mb-12 pb-6 sm:pb-8 gap-4 border-solid border-b border-white">
        <h2 className="text-2xl sm:text-4xl font-cinzel font-bold">Films</h2>
        <Buttons label="Watch Teaser" />
      </div>

      {/* Image Slider */}
      {/* <div className="relative w-full max-w-7xl h-[40vh] sm:h-[60vh] md:h-[80vh] rounded-xl overflow-hidden shadow-2xl bg-black">
        <img
          key={currentIndex}
          src={images[currentIndex]}
          alt={`Slide ${currentIndex}`}
          className={`w-full h-full object-cover transition-opacity duration-500 ease-in-out rounded-xl ${
            fade ? 'opacity-100' : 'opacity-0'
          }`}
        />
        <button
          onClick={prevImage}
          className="absolute left-6 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-30 hover:bg-opacity-60 text-black rounded-full p-3 text-2xl transition"
        >
          ‹
        </button>
        <button
          onClick={nextImage}
          className="absolute right-6 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-30 hover:bg-opacity-60 text-black rounded-full p-3 text-2xl transition"
        >
          ›
        </button>
      </div> */}

      {/* Dots */}
      {/* <div className="flex justify-center gap-3 mt-6">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-4 h-4 rounded-full transition-all duration-300 ${
              index === currentIndex ? 'bg-white scale-110' : 'bg-white/50'
            }`}
          />
        ))}
      </div> */}

      <div className="xl:max-w-[1170px] 2xl:max-w-[1260px]">
        <Swiper
          effect={'coverflow'}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={'auto'}
          loop={true}
          speed={1000}
          coverflowEffect={{
            rotate: 0,
            stretch: 500,
            depth: 200,
            modifier: 1,
            slideShadows: false,
          }}
          pagination={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          navigation={true}
          // autoplay={false}
          modules={[EffectCoverflow, Pagination, Autoplay, Navigation]}
          className="mySwiper film-swiper"
        >
          {images.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="relative w-full h-[550px] rounded-xl overflow-hidden bg-black">
                <img
                  src={item}
                  alt={`Slide ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default FilmsSection;
